export default grapesjs.plugins.add('snd-blocks', (editor, options) => {
  // Header Components
  const comps = editor.DomComponents;
  const defaultType = comps.getType('text');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  var headerTypes = [
    {value: 'h1', name: 'h1'},
    {value: 'h2', name: 'h2'},
    {value: 'h3', name: 'h3'},
    {value: 'h4', name: 'h4'},
    {value: 'h5', name: 'h5'},
    {value: 'h6', name: 'h6'}
  ];

  comps.addType('header', {
    model: defaultModel.extend({
      defaults: Object.assign({}, defaultModel.prototype.defaults, {
        'custom-name': 'Header',
        tagName: 'h1',
        droppable: false,
        content: 'Text Here',
        traits: ['id', {
          type: 'select',
          label: 'Size',
          name: 'tagName',
          options: headerTypes,
          changeProp: 1
        }],
      }),
      toHtml: function() {
        return '<h1>TEXT</h1>';
      },
      init() {
        this.listenTo(this, 'change:tagName', this.changeType);
      },
      changeType() {
        const coll = this.collection;
        const at = coll.indexOf(this);
        coll.remove(this);
        coll.add(this, { at });
      }
    },
    {
      isComponent: function(el) {
        if (el && el.tagName && ['H1','H2','H3','H4','H5','H6'].includes(el.tagName)) {
          return {type: 'header'};
        }
      }
    }),
    view: defaultType.view.extend({
      render: function() {
        defaultType.view.prototype.render.apply(this, arguments);
        return this;
      }
    })
  });

  const blockManager = editor.BlockManager;

  blockManager.add('header-block', {
    label: 'Header',
    content: {
      type: 'header'
    }
  })
}) 